<template>
  <div id="app">
    <!-- :include="['需要缓存的页面1', '需要缓存的页面2']" -->
    <keep-alive :include="['home','course','grade']">
      <router-view></router-view>
    </keep-alive>
    <messageToast ref="toast" />
  </div>
</template>

<script>
import { bus } from './config/bus';
export default {
  name: 'App',
  data() {
    //这里存放数据
    return {

    }
  },
  watch: {
    $route(to, from) {
      // console.log(to.path,'====');
    },
  },
  components: {
    
  },
  computed: {
    
  },
  mounted(){
    bus.$on('openPop',(data)=>{
      // console.log(data)
      this.$refs.toast.show(data);
    })
    // 获取配置文件
    this.$getRequest("common/config").then((res) => {
      if(res.code == 200){
          this.$store.state.config = res.data;
          this.$store.state.logoName = res.data.title;
          this.$store.state.logoImg = res.data.logo;
      }
    });
  },
  methods: {
    
  },
  beforeDestroy() {
    
  }
}
</script>

<style lang="less">
  *{
    margin: 0;
    padding: 0;
    -webkit-margin-before: 0;
    -webkit-margin-after: 0;
    -webkit-margin-before: 0;
    -webkit-margin-after: 0;
  }
  #app{
    font-family:ziti;
    // 中间区域最少要
    min-width: 1500px;
    overflow-y: auto;
    min-height: 100vh;
    background: #F5FEF7;
  }
  .el-popover{
    border: none !important;
    border-radius: 0 !important;
    box-shadow: none !important;
    padding: 0 !important;
  }
  .el-date-picker{
    .el-date-table{
      .el-date-table__row{
        .current{
          div{
            span{
              color: #FFFFFF !important;
              background: #5CC971 !important;
            }
          }
        }
        .available{
          &:hover{
            color: #5CC971 !important;
          }
        }
      }
    }
    .el-date-table td.today span{
      color: #5CC971 !important;
    }
    
  }
  .el-loading-mask{
    background: none !important;
    display: flex;
    justify-content: center;
    .el-loading-spinner{
      width: 140px;
      height: 100px;
      background: rgba(0,0,0,.7);
      border-radius: 10px;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      .el-icon-loading{
        color: #FFFFFF !important;
        font-size: 30px;
      }
      .el-loading-text{
        color: #FFFFFF !important;
        font-size: 18px;
        margin-top: 10px;
      }
    }
  }
  img {
    max-width: 100% !important;
    height: auto;
    display: block;
    object-fit:cover;
  }
  .el-header{
    width: 100%;
    padding: 0 !important;
  }
  .el-main{
    width: 100%;
    min-height: calc(100vh - 200px - 80px);
    padding: 0 !important;
  }
  .el-footer{
    width: 100%;
    padding: 0 !important;
    background: #F6F6F8 !important;
  }
  .el-dialog{
    background: transparent !important;
    box-shadow: none !important;
    .el-dialog__body{
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
  .goBack{
    position: absolute;
    left: 33px;
    top: 120px;
    width: 48px;
    height: 48px;
    img{
      width: 36px;
      // height: 36px;
      height: auto;
    }
  }
</style>
